import React, { FC, useEffect } from 'react';

// import Ar from './translations/Ar.json';
// import En from './translations/En.json';
import { IntlProvider } from 'react-intl';
import { getDirection } from './utils';
// import { locales } from './locales';
import { useRouter } from 'next/router';
import { useSyncLocalization } from '@/logic/hooks';

// const messages = {
//   [locales.EN]: En,
//   [locales.AR]: Ar,
// };

interface LanguageProviderProps {
  children: React.ReactNode;
  serverMessages: any;
}

export const LanguageProvider: FC<LanguageProviderProps> = props => {
  const { locale } = useRouter();
  useSyncLocalization();
  const { children, serverMessages } = props;

  useEffect(() => {
    const dir = getDirection(locale);
    document.dir = dir;
  }, [locale]);

  // const messagesLocale =
  //   locale === 'default'
  //     ? checkIsBrowser()
  //       ? window.location.href.split('/')[3]
  //       : 'en'
  //     : locale;

  return (
    <IntlProvider messages={serverMessages} locale={locale}>
      {children}
    </IntlProvider>
  );
};
